// ============================================================
// MASH Machine-Evidence — honesty presentational tokens (pure, no React)
// ============================================================
// Maps honesty resolutions -> colors, keyed to the shared `dt` redesign tokens
// + the MASH design palette (forest / amber / terracotta / slate). SP-2 owns the
// final card-level visual polish; these are the neutral defaults the SP-1a atoms
// render with so the honesty state reads correctly out of the box.

import { dt } from "../../../themes/redesignTokens";
import type { VerdictTone } from "./honestyEngine";
import type { FreshnessState } from "../../../chatBot/models/machineEvidenceModels";

export const EM_DASH = "—";

export interface TonePalette {
  fg: string;
  bg: string;
  border: string;
}

/** Verdict tone palette — slate NEUTRAL is the dignified default, never error. */
export const VERDICT_TONE_COLORS: Record<VerdictTone, TonePalette> = {
  positive: { fg: "#1E7A46", bg: "rgba(39,174,96,0.10)", border: "rgba(39,174,96,0.30)" },
  warning: { fg: "#B5811A", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.32)" },
  critical: { fg: "#A8442C", bg: "rgba(192,57,43,0.10)", border: "rgba(192,57,43,0.30)" },
  neutral: { fg: dt.textSecondary, bg: "rgba(107,114,128,0.10)", border: "rgba(107,114,128,0.26)" },
};

/** Freshness strip palette. */
export const FRESHNESS_COLORS: Record<FreshnessState, TonePalette> = {
  LIVE: { fg: "#1E7A46", bg: "rgba(39,174,96,0.10)", border: "rgba(39,174,96,0.28)" },
  STALE: { fg: "#B5811A", bg: "rgba(245,158,11,0.10)", border: "rgba(245,158,11,0.28)" },
  DARK: { fg: dt.textMuted, bg: "rgba(107,114,128,0.10)", border: dt.cardBorder },
};

/** The green-dot color for a `live_zero` (armed & quiet real zero). */
export const LIVE_ZERO_DOT = dt.roleGreen;

/** Muted color for pending / cold_armed / absent / neutral placeholders. */
export const PLACEHOLDER_FG = dt.textMuted;
